import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

export const RM_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'RM',
   sections: [
      // A. Role Satisfaction & Engagement
      {
         id: 'section_a_role_satisfaction_engagement',
         revieweeTitle: 'Role Satisfaction & Engagement',
         reviewerTitle: 'Role Effectiveness & Engagement',
         questions: [
            {
               id: 'role_satisfaction',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall, how satisfied are you in your Regional Manager role?',
               revieweeOptions: [
                  { label: 'Very satisfied', value: 'very_satisfied' },
                  { label: 'Satisfied', value: 'satisfied' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Somewhat dissatisfied', value: 'somewhat_dissatisfied' },
                  { label: 'Dissatisfied', value: 'dissatisfied' },
               ],
               reviewerLabel: 'How effective is the RM in executing their role and sustaining engagement across the region?',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'role_factors',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership development and coaching opportunities', value: 'leadership_development_coaching' },
                  { label: 'Partnership with Director of Operations', value: 'partnership_with_do' },
                  { label: 'Collaboration with Area Managers', value: 'collaboration_with_ams' },
                  { label: 'Regional performance and accountability', value: 'regional_performance_accountability' },
                  { label: 'Workload / travel demands', value: 'workload_travel_demands' },
                  { label: 'Culture and engagement of hospital teams', value: 'culture_engagement_hospital_teams' },
               ],
               revieweeLabel: 'Factors most influencing your experience (select up to 3)',
               reviewerLabel: '',
               maxSelections: 3,
               hasOther: true,
            },
            {
               id: 'role_engagement_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               labelIsHtml: true,
               reviewerLabel: 'Key observations (including sustainability of workload and scope) <span class="required-asterisk">*</span>',
            },
         ],
      },

      // B. Leadership & Talent Development
      {
         id: 'section_b_leadership_talent',
         revieweeTitle: 'Leadership & Talent Development',
         reviewerTitle: 'Leadership & Talent Development',
         questions: [
            {
               id: 'developing_hms_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'How effective do you feel in developing Hospital Managers (HMs)?',
               revieweeOptions: [
                  { label: 'Extremely effective', value: 'extremely_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
               reviewerLabel: 'Effectiveness in coaching, mentoring, and developing HMs',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'developing_coss_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'How effective do you feel in developing Chiefs of Staff (COSs)?',
               revieweeOptions: [
                  { label: 'Extremely effective', value: 'extremely_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
               reviewerLabel: 'Effectiveness in coaching, mentoring, and developing COSs',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'impact_areas_strength',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Coaching and mentoring leaders', value: 'coaching_mentoring_leaders' },
                  { label: 'Driving performance accountability', value: 'driving_performance_accountability' },
                  { label: 'Fostering a healthy leadership culture', value: 'healthy_leadership_culture' },
                  { label: 'Supporting retention and engagement initiatives', value: 'retention_engagement_initiatives' },
                  { label: 'Improving operational or financial outcomes', value: 'improving_operational_financial_outcomes' },
               ],
               revieweeLabel: 'Areas where you have made the strongest impact (select all that apply)',
               reviewerLabel: 'Areas of strength (select all that apply)',
               hasOther: true,
            },
            {
               id: 'support_resources_needed',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership development tools or training', value: 'leadership_development_tools_training' },
                  { label: 'Time and capacity for coaching', value: 'time_capacity_for_coaching' },
                  { label: 'Cross-hospital collaboration best practices', value: 'cross_hospital_collaboration_best_practices' },
                  { label: 'Performance management / coaching models', value: 'performance_management_coaching_models' },
                  { label: 'Financial performance tools (P&L review, budgeting, cost control)', value: 'financial_performance_tools' },
                  { label: 'Revenue growth strategies (pricing, service mix, appointment optimization)', value: 'revenue_growth_strategies' },
                  { label: 'Expense management support (labor efficiency, supply cost reduction)', value: 'expense_management_support' },
                  { label: 'Monthly KPI / scorecard tracking (margin, productivity, revenue per doctor)', value: 'monthly_kpi_scorecard_tracking' },
               ],
               revieweeLabel: 'Areas where you would like additional support or resources (select all that apply)',
               reviewerLabel: 'Areas for development / enablement (select all that apply)',
               hasOther: true,
            },
            {
               id: 'leadership_talent_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               labelIsHtml: true,
               reviewerLabel: 'Support or enablement needed from DO or organization <span class="required-asterisk">*</span>',
            },
         ],
      },

      // C. Regional Performance & Strategic Impact
      {
         id: 'section_c_regional_performance',
         revieweeTitle: 'Regional Performance & Strategic Impact',
         reviewerTitle: 'Regional Performance & Strategic Impact',
         questions: [
            {
               id: 'confidence_influence_performance',
               type: 'radio',
               required: true,
               revieweeLabel: 'How confident are you in your ability to influence regional performance through HMs and COSs?',
               revieweeOptions: [
                  { label: 'Very confident', value: 'very_confident' },
                  { label: 'Confident', value: 'confident' },
                  { label: 'Somewhat confident', value: 'somewhat_confident' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Not confident', value: 'not_confident' },
               ],
               reviewerLabel: 'Ability to drive operational, financial, and cultural outcomes across multiple hospitals',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'progress_areas',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Regional operational outcomes', value: 'regional_operational_outcomes' },
                  { label: 'Hospital financial performance', value: 'hospital_financial_performance' },
                  { label: 'Adoption of company initiatives and standards', value: 'adoption_initiatives_standards' },
                  { label: 'Change management and process improvements', value: 'change_management_process_improvements' },
                  { label: 'Team alignment and communication', value: 'team_alignment_communication' },
               ],
               revieweeLabel: 'Where do you see the greatest progress? (select all that apply)',
               reviewerLabel: 'Key priorities showing progress (select all that apply)',
               hasOther: true,
            },
            {
               id: 'regional_performance_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               labelIsHtml: true,
               reviewerLabel: 'Comments (including influence vs. outcome considerations) <span class="required-asterisk">*</span>',
            },
         ],
      },

      // D. Communication & Cross-Functional Partnership
      {
         id: 'section_d_communication_partnership',
         revieweeTitle: 'Communication & Cross-Functional Partnership',
         reviewerTitle: 'Communication & Cross-Functional Partnership',
         questions: [
            {
               id: 'communication_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'How effective are you in ensuring clear, timely communication across your region?',
               revieweeOptions: [
                  { label: 'Extremely effective', value: 'extremely_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
               reviewerLabel: 'Effectiveness in collaboration and communication with HMs, COSs, Area Managers, and support teams',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'communication_gaps',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Alignment between hospitals and Service Center / PMO', value: 'alignment_hospitals_service_center_pmo' },
                  { label: 'Consistency of regional messaging', value: 'consistency_regional_messaging' },
                  { label: 'Clarity and effectiveness of communication from the DO', value: 'clarity_communication_from_do' },
               ],
               revieweeLabel: 'What communication gaps or alignment challenges are currently impacting success?',
               reviewerLabel: '',
               hasOther: true,
            },
            {
               id: 'communication_strengths',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clarity and timeliness of messaging', value: 'clarity_timeliness_messaging' },
                  { label: 'Collaboration across AMs, HMs, and COSs', value: 'collaboration_across_hm_cos' },
                  { label: 'Alignment with Director of Operations', value: 'alignment_do' },
               ],
               revieweeLabel: '',
               reviewerLabel: 'Strengths',
               hasOther: true,
            },
            {
               id: 'opportunities_improvement',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Cross-hospital communication', value: 'cross_hospital_communication' },
                  { label: 'Alignment of regional priorities', value: 'alignment_regional_priorities' },
                  { label: 'Collaboration with DO or support teams', value: 'collaboration_do_support_teams' },
               ],
               revieweeLabel: '',
               reviewerLabel: 'Opportunities for improvement',
               hasOther: true,
            },

            // Partnership Effectiveness (ratings)
            {
               id: 'partnership_hm_rating',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<p></p><br><span class="review-subtitle">Partnership Effectiveness</span><p></p><i>Hospital Manager (HM)</i> <span class="required-asterisk">*</span>',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: '',
               reviewerOptions: [],
            },
            {
               id: 'partnership_hm_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust / connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve HM partnership? (select up to 2)',
               reviewerLabel: '',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'partnership_cos_rating',
               type: 'radio',
               required: true,
               revieweeLabel: 'Chief of Staff (COS)',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: '',
               reviewerOptions: [],
            },
            {
               id: 'partnership_cos_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust / connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve COS partnership? (select up to 2)',
               reviewerLabel: '',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'partnership_do_rating',
               type: 'radio',
               required: true,
               revieweeLabel: 'Director of Operations (DO)',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: '',
               reviewerOptions: [],
            },
            {
               id: 'partnership_do_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust / connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve DO partnership? (select up to 2)',
               reviewerLabel: '',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'partnership_cosa_rating',
               type: 'radio',
               required: true,
               revieweeLabel: 'Chief of Staff Advisor',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: '',
               reviewerOptions: [],
            },
            {
               id: 'partnership_cosa_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust / connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve Chief of Staff Advisor partnership? (select up to 2)',
               reviewerLabel: '',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'communication_partnership_notes',
               type: 'textarea',
               required: false,
               labelIsHtml: true,
               maxLength: 1000,
               revieweeLabel: '<br>Notes (optional)',
               reviewerLabel: 'Comments',
            },
         ],
      },

      // E. Talent Retention & Engagement
      {
         id: 'section_e_talent_retention',
         revieweeTitle: 'Talent Retention & Engagement',
         reviewerTitle: 'Talent Retention & Engagement',
         questions: [
            {
               id: 'retention_confidence',
               type: 'radio',
               required: true,
               revieweeLabel: 'How confident are you that your region is effectively retaining key talent?',
               revieweeOptions: [
                  { label: 'Very confident', value: 'very_confident' },
                  { label: 'Confident', value: 'confident' },
                  { label: 'Somewhat confident', value: 'somewhat_confident' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Not confident', value: 'not_confident' },
               ],
               reviewerLabel: 'Effectiveness in supporting retention and engagement across the region',
               reviewerOptions: [
                  { label: 'Highly effective', value: 'highly_effective' },
                  { label: 'Effective', value: 'effective' },
                  { label: 'Somewhat effective', value: 'somewhat_effective' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
                  { label: 'Ineffective', value: 'ineffective' },
               ],
            },
            {
               id: 'retention_strategies_success',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership development programs', value: 'leadership_development_programs' },
                  { label: 'Engagement initiatives', value: 'engagement_initiatives' },
                  { label: 'Recognition and reward practices', value: 'recognition_reward_practices' },
                  { label: 'Succession planning', value: 'succession_planning' },
               ],
               revieweeLabel: 'Retention strategies implemented successfully (select all that apply)',
               reviewerLabel: 'Observed strengths (select all that apply)',
               hasOther: true,
            },
            {
               id: 'retention_examples_impact',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Example(s) of successful retention strategies and impact',
               reviewerLabel: '',
            },
            {
               id: 'retention_focus_areas',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Reducing burnout for HMs / COSs', value: 'reducing_burnout_hm_cos' },
                  { label: 'Career growth and succession planning', value: 'career_growth_succession_planning' },
                  { label: 'Regional culture and engagement', value: 'regional_culture_engagement' },
               ],
               revieweeLabel: 'Areas to focus on moving forward (select all that apply)',
               reviewerLabel: 'Areas to focus on (select all that apply)',
               hasOther: true,
            },
            {
               id: 'retention_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               labelIsHtml: true,
               reviewerLabel: 'Comments (include examples or metrics where possible) <span class="required-asterisk">*</span>',
            },
         ],
      },

      // F. Personal Growth & Future Goals
      {
         id: 'section_f_growth_goals',
         revieweeTitle: 'Personal Growth & Future Goals',
         reviewerTitle: 'Development Path & Future Readiness',
         questions: [
            {
               id: 'growth_areas_next_12_months',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Coaching and talent development', value: 'coaching_talent_development' },
                  { label: 'Regional strategy and prioritization', value: 'regional_strategy_prioritization' },
                  { label: 'Financial / operational analysis', value: 'financial_operational_analysis' },
                  { label: 'Change management', value: 'change_management' },
                  { label: 'Communication and influence', value: 'communication_influence' },
               ],
               revieweeLabel: 'Which areas are you most interested in developing over the next 12 months? (select all that apply)',
               reviewerLabel: 'Development priorities for the next review period (select all that apply)',
               hasOther: true,
            },
            {
               id: 'readiness_alignment',
               type: 'radio',
               required: true,
               revieweeLabel: '',
               revieweeOptions: [],
               reviewerLabel: 'Alignment between RM growth goals and observed readiness for broader leadership roles',
               reviewerOptions: [
                  { label: 'Highly aligned', value: 'highly_aligned' },
                  { label: 'Aligned', value: 'aligned' },
                  { label: 'Somewhat aligned', value: 'somewhat_aligned' },
                  { label: 'Misaligned', value: 'misaligned' },
               ],
            },
         ],
      },

      // G. Performance Highlights & Reflection
      {
         id: 'section_g_highlights_reflection',
         revieweeTitle: 'Performance Highlights & Reflection',
         reviewerTitle: 'Highlights & Reflection',
         questions: [
            {
               id: 'wins_kpis',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Identify three (3) most significant performance wins from the past year and describe the measurable impact.</span><p></p>Most improved KPIs and why <span class="required-asterisk">*</span>',
               reviewerLabel: '',
            },
            {
               id: 'wins_financial',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Financial wins (margin, revenue, labor efficiency, cost control)',
               reviewerLabel: '',
            },
            {
               id: 'wins_operational',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Operational wins (patient flow, scheduling, medical quality, compliance)',
               reviewerLabel: '',
            },
            {
               id: 'role_evolution',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               labelIsHtml: true,
               revieweeLabel:
                  '<p></p><br><span class="review-subtitle">Additional reflection:</span><p></p>How do you see your role evolving to better support retention and regional performance? <span class="required-asterisk">*</span>',
               reviewerLabel: '',
            },
            {
               id: 'missed_expectations_stretched',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Where did you miss expectations or feel stretched?',
               reviewerLabel: '',
            },
            {
               id: 'leader_improvement_area',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'One area you need to improve as a leader',
               reviewerLabel: '',
            },
            {
               id: 'feedback_from_hms_coss',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Feedback you believe HMs / COSs would give you',
               reviewerLabel: '',
            },
            {
               id: 'biggest_obstacles',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Biggest obstacle(s) to success in the region',
               reviewerLabel: '',
            },
            {
               id: 'where_need_do_support',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Where you need DO support',
               reviewerLabel: 'DO commitments to support RM development',
            },
         ],
      },
   ],
}
